<template>
  <el-card class="page-container">
    <el-row class="title-biaoti">充值币商配置</el-row>
    <el-row class="search">
      <el-form :inline="true" :model="queryInfo">
        <el-form-item label="状态">
          <el-select v-model="queryInfo.valid" placeholder="请选择">
            <el-option label="有效" value="1" />
            <el-option label="无效" value="0" />
          </el-select>
        </el-form-item>
        <el-form-item label="渠道">
          <el-select
            style="width: 200px"
            v-model="queryInfo.channel"
            placeholder="请输入渠道"
          >
            <el-option
              v-for="(item, itemIndex) in channelsList"
              v-bind:key="itemIndex"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="币商ID">
          <el-input v-model="queryInfo.rid" placeholder="请输入币商ID" />
        </el-form-item>
        <el-button type="primary" @click="query(true)" :loading="login"
          >查询</el-button
        >
        <el-button type="warning" @click="operate(1)">新增 </el-button>
      </el-form>
    </el-row>
    <el-row>
      <el-table
        :data="datalist"
        style="width: 100%"
        v-loading="login"
        stripe
        border
      >
        <el-table-column
          prop="orderId"
          label="排序权重"
          align="center"
          width="80"
        />
        <el-table-column label="宣传图" align="center">
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="scope.row.adUrl"
              :preview-src-list="[scope.row.adUrl]"
            />
          </template>
        </el-table-column>
        <el-table-column prop="rid" label="币商RID" align="center" />
        <el-table-column prop="name" label="币商昵称" align="center" />
        <el-table-column prop="countryCode" label="国家码" align="center" />
        <el-table-column prop="whatsapp" label="whatsapp" align="center" />
        <el-table-column
          prop="newSellerStartDate"
          label="币商起始时间"
          align="center"
        />
        <el-table-column
          prop="newSellerEndDate"
          label="币商结束时间"
          align="center"
        />
        <el-table-column label="支付渠道">
          <template slot-scope="scope">
            <!-- detailData有支付name和url图片，渲染出来 -->
            <ul>
              <li v-for="(item, idx) in scope.row.detailData" :key="idx">
                <el-image
                  style="width: 20px; height: 20px"
                  :src="item.url"
                  fit="scale-down"
                />
                {{ item.name }}
              </li>
            </ul>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.valid == 1" type="success">有效</el-tag>
            <el-tag v-else type="danger">无效</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="channel" label="渠道" align="center" />
        <el-table-column prop="operator" label="操作人" align="center" />
        <el-table-column
          prop="createDate"
          label="创建时间"
          width="92"
          align="center"
        />
        <el-table-column
          prop="fixDate"
          label="修改时间"
          width="92"
          align="center"
        />
        <el-table-column label="是否在列表" align="center" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.inList == 1" type="success">在</el-tag>
            <el-tag v-else type="info">不在</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="扶持截至时间" align="center" width="180">
          <template slot-scope="scope">
            <span v-if="scope.row.supportTime && scope.row.supportTime != 0">
              {{ formatSupportTime(scope.row.supportTime) }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="operate(2, scope.row)">
              修改
            </el-button>
            <el-button type="success" size="mini" @click="openSupportDialog(scope.row)">
              扶持
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :total="pageInfo.total"
        :current-page.sync="pageInfo.page"
        :page-size="pageInfo.pageSize"
      >
      </el-pagination>
    </el-row>

    <el-dialog
      :title="isAdd ? '新增配置' : '更新配置'"
      :visible.sync="dialog"
      width="60%"
      :before-close="handleClose"
    >
      <div class="item">
        <span>RID：</span>
        <el-input type="text" v-model="data.rid" />
      </div>
      <div class="item">
        <span>排序权重：</span>
        <el-input type="number" v-model="data.orderId" />
      </div>
      <div class="item">
        <span>国家：</span>
        <el-select
          class="header-item"
          v-model="data.countryCode"
          placeholder=""
        >
          <el-option
            v-for="(item, itemIndex) in countryList"
            :key="itemIndex"
            :label="item.country"
            :value="item.countryCode"
          ></el-option>
        </el-select>
      </div>
      <div class="item">
        <span>whatsapp：</span>
        <el-input type="text" v-model="data.whatsapp" />
      </div>
      <div class="item">
        <span>新币商起始时间：</span>
        <el-date-picker
          v-model="data.newSellerStartDate"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期时间"
        >
        </el-date-picker>
      </div>
      <div class="item">
        <span>新币商结束时间：</span>
        <el-date-picker
          v-model="data.newSellerEndDate"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期时间"
        >
        </el-date-picker>
      </div>
      <div class="item">
        <span>状态：</span>
        <el-select v-model="data.valid" placeholder="请选择">
          <el-option label="有效" value="1" />
          <el-option label="无效" value="0" />
        </el-select>
      </div>
      <!-- 支付类型 -->
      <div class="item">
        <span>支付类型：</span>
        <div class="support_method">
          <div
            v-for="(item, itemIndex) in pay_config"
            :key="itemIndex"
            @click="item.select = !item.select"
            class="method_item"
            :class="{ method_item_checked: item.select }"
          >
            <div
              class="icon"
              :class="{ checked: item.select, 'el-icon-check': item.select }"
            />
            <el-image
              v-if="item.value !== ''"
              style="width: 20px; height: 20px"
              :src="item.value"
              fit="scale-down"
            />
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="item">
        <span>宣传图：</span>
        <el-upload
          class="avatar-uploader"
          action=""
          :auto-upload="false"
          :show-file-list="false"
          :on-change="uploadImage"
          ref="upload"
        >
          <el-image
            v-if="data.adUrl !== ''"
            style="width: 188px; height: auto"
            :src="data.adUrl"
            :preview-src-list="[data.adUrl]"
            fit="scale-down"
          ></el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog = false" :loading="uploading"
          >取 消</el-button
        >
        <el-button type="primary" @click="submit" :loading="uploading">
          {{ isAdd ? '新 增' : '更 新' }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 扶持对话框 -->
    <el-dialog
      title="币商扶持"
      :visible.sync="supportDialog"
      width="500px"
      :before-close="handleSupportClose"
    >
      <el-form :model="supportForm" label-width="120px">
        <el-form-item label="币商UID">
          <el-input v-model="supportForm.uid" placeholder="请输入币商UID" />
        </el-form-item>
        <el-form-item label="扶持日期">
          <el-date-picker
            v-model="supportForm.date"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="supportDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitSupport" :loading="supportLoading">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import { id } from 'vue-json-editor/assets/jsoneditor';

export default {
  data() {
    return {
      login: false,
      datalist: [],
      pageInfo: { page: 1, pageSize: 10, total: 0 },
      countryList: [],
      queryInfo: {
        valid: '1',
        rid: '',
        channel: '',
      },
      channelsList: this.$store.state.channels,
      pay_config: [],

      dialog: false,
      isAdd: true,
      data: {
        rid: '',
        orderId: '',
        countryCode: '',
        whatsapp: '',
        newSellerStartDate: '',
        newSellerEndDate: '',
        valid: '1',
        adUrl: '',
        detailData: [],
      },
      uploading: false,
      supportDialog: false,
      supportLoading: false,
      supportForm: {
        uid: '',
        date: '',
      },
      currentSupportRow: null,
    }
  },
  created() {
    this.query(true)
    this.get_config()
    this._getCountry()
  },
  methods: {
    async _getCountry() {
      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.CountryList,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })
      if (res !== null) {
        this.countryList = res.data.countryList
        this.countryList.unshift({
          country: 'all',
          countryCode: 'all',
        })
      }
    },
    async operate(type, obj) {
      this.dialog = true
      if (type == 1) {
        this.isAdd = true
      } else if (type == 2) {
        this.isAdd = false
        obj.valid = obj.valid.toString()
        this.data = obj
        this.data.newSellerStartDate = this.data.newSellerStartDate.split(" ")[0]
        this.data.newSellerEndDate = this.data.newSellerEndDate.split(" ")[0]
      }
      // 看看detailData哪些被选中了config_pay
      this.pay_config.forEach((item) => {
        item.select = false
        obj.detailData.forEach((item2) => {
          if (item.name == item2.name) {
            item.select = true
          }
        })
      })
    },
    async submit() {
      this.data.detailData = []
      this.pay_config.forEach((item) => {
        if (item.select) {
          this.data.detailData.push({ name: item.name, url: item.value })
        }
      })
      if (this.isAdd) {
        const { data: res } = await this.$axios.post(
          this.$store.getters.path.config_coin_seller_add +
            '?username=' +
            this.$store.getters.username +
            '&token=' +
            this.$store.getters.token,
          {
            rid: this.data.rid,
            orderId: this.data.orderId,
            valid: this.data.valid,
            adUrl: this.data.adUrl,
            countryCode: this.data.countryCode,
            whatsapp: this.data.whatsapp,
            newSellerStartDate: this.data.newSellerStartDate,
            newSellerEndDate: this.data.newSellerEndDate,
            detailData: this.data.detailData,
          }
        )
        if (res.code != 0) return this.$message(res.msg)
        this.$message.success('新增成功')
      } else {
        const { data: res } = await this.$axios.post(
          this.$store.getters.path.config_coin_seller_update +
            '?username=' +
            this.$store.getters.username +
            '&token=' +
            this.$store.getters.token,
          {
            id: this.data.id,
            rid: this.data.rid,
            orderId: this.data.orderId,
            valid: this.data.valid,
            adUrl: this.data.adUrl,
            countryCode: this.data.countryCode,
            whatsapp: this.data.whatsapp,
            newSellerStartDate: this.data.newSellerStartDate,
            newSellerEndDate: this.data.newSellerEndDate,
            detailData: this.data.detailData,
            uid: this.data.uid,
          }
        )
        if (res.code != 0) return this.$message(res.msg)
        this.$message.success('修改成功')
      }
      this.handleClose()
      this.query(true)
    },
    async query(page) {
      this.login = true
      if (page) this.pageInfo.page = 1
      const params = {
        username: this.$store.getters.username,
        token: this.$store.getters.token,
        page: this.pageInfo.page,
        valid: this.queryInfo.valid,
      }
      if (this.queryInfo.rid != '') params.rid = this.queryInfo.rid
      if (this.queryInfo.channel != '' && this.queryInfo.channel !== 'all')
        params.channel = this.queryInfo.channel
      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.config_coin_seller_query,
        withCredentials: true,
        params,
      })
      this.login = false
      if (res.code != 0) return this.$message(res.msg)
      this.datalist = res.data.data
      this.pageInfo.total = res.data.total
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val
      this.query()
    },
    handleClose() {
      this.data = {
        rid: '',
        orderId: '',
        valid: '1',
        adUrl: '',
        detailData: [],
      }
      this.pay_config.forEach((item) => {
        item.select = false
      })
      this.$refs.upload.clearFiles()
      this.dialog = false
    },
    async get_config() {
      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.config_coin_seller_config,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })
      if (res.code != 0) return this.$message(res.msg)
      res.data.forEach((item) => {
        item.select = false
      })
      this.pay_config = res.data
    },
    async uploadImage(file) {
      this.uploading = true
      const formdata = new FormData()
      formdata.append('file', file.raw)
      formdata.append('cover', 0)
      formdata.append('dir', 'coin_seller_ad/icon/')
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        formdata
      )
      this.uploading = false
      if (res.code !== 0) {
        this.$refs.upload.clearFiles()
        return this.$message.error('文件上传失败请重新选择文件上传')
      }
      this.data.adUrl = res.data
    },
    formatSupportTime(timestamp) {
      if (!timestamp || timestamp == 0) return '-'
      const date = new Date(timestamp * 1000)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    openSupportDialog(row) {
      this.currentSupportRow = row
      this.supportForm.uid = row.uid || ''
      this.supportForm.date = ''
      this.supportDialog = true
    },
    handleSupportClose() {
      this.supportForm = {
        uid: '',
        date: '',
      }
      this.currentSupportRow = null
      this.supportDialog = false
    },
    async submitSupport() {
      if (!this.supportForm.uid) {
        return this.$message.warning('请输入币商UID')
      }
      this.supportLoading = true
      const params = {
        username: this.$store.getters.username,
        token: this.$store.getters.token,
        uid: this.supportForm.uid,
      }
      if (this.supportForm.date) {
        params.date = this.supportForm.date
      }
      try {
        const { data: res } = await this.$axios({
          type: 'GET',
          url: this.$store.getters.path.config_coin_seller_support,
          withCredentials: true,
          params,
        })
        this.supportLoading = false
        if (res.code != 0) return this.$message.error(res.msg)
        this.$message.success('扶持操作成功')
        this.handleSupportClose()
        this.query()
      } catch (error) {
        this.supportLoading = false
        this.$message.error('操作失败')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.search {
  display: flex;
  align-items: center;

  > * {
    margin: 0 3px;
  }
}

li {
  display: flex;
  align-items: center;
  gap: 4px;
}

.item {
  display: grid;
  grid-template-columns: 1fr 8fr;
  align-items: center;
  padding: 5px 0;

  span {
    white-space: nowrap;
    padding: 0 5px;
  }

  .support_method {
    display: flex;
    gap: 20px;

    .method_item {
      border: 1px solid #dcdfe6;
      padding: 8px 14px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      gap: 4px;
      position: relative;

      .icon {
        position: absolute;
        right: 0;
        top: 0;
        cursor: pointer;
        background-color: white;
        border-radius: 0 8px 0 2px;
        transition: all 0.2s;
      }

      .checked {
        background-color: #074481;
        color: white;
        border-radius: 0 6px 0 2px;
      }
    }

    .method_item_checked {
      border: 1px solid #074481;
    }
  }
}

.avatar-uploader {
  display: inline-block;
  width: 188px;
  height: 188px;
  position: relative;
  overflow: hidden;
  border: 1px solid #dcdfe6;

  .el-icon-plus {
    font-size: 48px;
    color: #8c939d;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .el-image {
    width: 100%;
    height: 100%;
  }
}
</style>
